import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getUnit(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams);
}

export async function getUnitByMitra(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createUnit(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/unit" + pathname, body);
}

export async function updateUnit(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/unit" + pathname, body);
}

export async function deleteUnit(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/unit" + pathname, { data: body });
}

export async function bulkCreateUnit(units) {
  return await instance({
    baseURL: baseURL,
  }).post("/unit/bulk", { units });
}
